import { ChangeEvent, FC, useCallback } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import DebouncedTextField from 'components/DebouncedTextField';

import { useSearch } from 'components/Search';

type Props = {};

const TableSearchField: FC<Props> = props => {
  const { search, setSearch } = useSearch();

  const handleSearchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setSearch(event.target.value);
    },
    [setSearch]
  );

  return (
    <DebouncedTextField
      autoFocus
      variant="standard"
      label="Paieška"
      value={search}
      onChange={handleSearchChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default TableSearchField;
